const initialstate = []

function tab2Inputs(state = initialstate, action) {
    switch (action.type) {
        case "set_tab2Inputs":
            return  action.payload 
        case "clear_set_tab2Inputs":
            return initialstate

        default:
            return state
    }
}

export default tab2Inputs;